import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MeterConsumptionGranularityKeys, MeterDownloadWizardDto } from '@app/shared/models/meter/meter-download-wizard-data';
import { CheckedMeter } from '@app/shared/models/meter/meter-wizard-checked-meter';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-meter-list-selection',
  templateUrl: './meter-list-selection.component.html',
  styleUrls: ['./meter-list-selection.component.scss'],
})
export class MeterListSelectionComponent implements OnInit {
  @Output() checkMeter$ = new EventEmitter<CheckedMeter>();
  @Output() title = new EventEmitter<string>();
  @Output() nextButtonStatus = new EventEmitter<boolean>();
  @Input() checkedMeter: MeterDownloadWizardDto[] = [];
  @Input() granularity: MeterConsumptionGranularityKeys = '' as MeterConsumptionGranularityKeys;
  @Input() isCurrent = false;

  constructor(public translate: TranslateService) {}

  public ngOnInit() {
    this.title.emit(this.translate.instant('module.shared.excelDownloadWizard.titleText2'));
    this.nextButtonStatus.emit(this.checkedMeter.length === 0);
  }

  public onCheckMeter($event: CheckedMeter): void {
    this.checkMeter$.emit($event);
    this.getNextButtonStatus();
  }

  public getNextButtonStatus() {
    this.checkedMeter.length === 0 ? this.nextButtonStatus.emit(true) : this.nextButtonStatus.emit(false);
  }
}
